import { render } from "./ClubDealOpen.vue?vue&type=template&id=fb40d0a4&scoped=true&ts=true"
import script from "./ClubDealOpen.vue?vue&type=script&lang=ts"
export * from "./ClubDealOpen.vue?vue&type=script&lang=ts"

import "./ClubDealOpen.vue?vue&type=style&index=0&id=fb40d0a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb40d0a4"]])

export default __exports__